// export function getTargetScoringTemplates(){
//     return targetScoringTemplates;
// }

export function getLanguage(key) {
  return shootingProgramLanguages[key];
}

export function getLanguages() {
  return Object.values(shootingProgramLanguages);
}

export function getLanguageAbbreviation(targetLanguage) {
  // Returns the abbreviated version of a given language
  const languageIndex = Object.values(shootingProgramLanguages).findIndex(
    (value) => value === targetLanguage
  );
  const languageShort = Object.keys(shootingProgramLanguages)[languageIndex];
  return languageShort;
}

export function fromTimeToIsoTime(time) {
  let minutes = "";
  let seconds = "";
  if (!time) {
    time = "00:00:00";
  }
  const splitTime = time.split(":");
  if (splitTime[0] !== "00") {
    minutes = Number(splitTime[0]) + "M";
  }
  if (splitTime[1] !== "00") {
    seconds = Number(splitTime[1]) + "S";
  }
  const isoTime =
    minutes !== "" || seconds !== "" ? "PT" + minutes + seconds : ""; // Return ISO time only if minutes and/or seconds is set
  return isoTime;
}

export function getCategoryClass() {
  return categoryClass;
}

export function getCategorySelection() {
  return categorySelection;
}

export function getEventClass() {
  return eventClass;
}

export function getEventTemplateAll() {
  return eventTemplateAll;
}

export function getExecutionMode() {
  return executionMode;
}
//Kategorier
const categoryClass = ["Class"];
const categorySelection = [
  { id: "1" },
  { id: "2" },
  { id: "3" },
  { id: "4" },
  { id: "5" },
  { id: "V55" },
  { id: "V65" },
  { id: "V73" },
  { id: "V75" },
  { id: "HK416" },
  { id: "R" },
  { id: "ER" },
  { id: "J" },
  { id: "EJ" },
  { id: "NU" },
  { id: "NV" },
  { id: "KIK" },
  { id: "JEG" },
  { id: "Å" },
  { id: "SK1" },
  { id: "SK2" },

  { id: "810" },
  { id: "811" },
  { id: "812" },
  { id: "813" },
  { id: "815" },
  { id: "816" },
];

const eventClass = ["DFS_25_SKUDD", "DFS_35_SKUDD"];

const eventTemplateAll = ['SERIES_1', 'SERIES_2', 'SERIES_3', 'SERIES_4', 'SERIES_5'];

const executionMode = ["Normal", "Simple"];

//Validate time format input
export function validateTimeInput(time) {
  if (time == undefined) return true;

  if (time.length <= 0 || time.length > 8) {
    return false; //empty or over length limit
  }

  let splitTime = time.split(":");

  if (splitTime.length <= 3) {
    for (let timeValue of splitTime) {
      if (timeValue.length != 2) {
        return false; //Timevalue does not contain two numbers
      }
    }
  } else return false; // Has more than 3 time values

  for (let i = 0; i < splitTime.length; i++) {
    if (!isNaN(parseInt(splitTime[i]))) {
      let timeNumber = parseInt(splitTime[i]);

      if (timeNumber < 0 || timeNumber > 99) {
        return false;
      }
    } else {
      return false;
    }
  }

  //Has passed all tests succsesfully
  return true;
}

// const targetScoringTemplates = [
//     {id:"ADF FIG 11", subTargetIndex: null},
//     {id:"ADF FIG 11 Type D"},
//     {id:"ADF FIG 12"},
//     {id:"ADF FIG 12 Type D"},
//     {id:"AUS CQB11"},
//     {id:"AUS ICFRA 300m"},
//     {id:"AUS ICFRA 300yd"},
//     {id:"AUS ICFRA 400m"},
//     {id:"AUS ICFRA 400yd"},
//     {id:"AUS ICFRA 500m"},
//     {id:"AUS ICFRA 500yd"},
//     {id:"AUS ICFRA 600m"},
//     {id:"AUS ICFRA 600yd"},
//     {id:"AUS ICFRA 700m"},
//     {id:"AUS ICFRA 700yd"},
//     {id:"AUS ICFRA 800m"},
//     {id:"AUS ICFRA 800yd"},
//     {id:"AUS ICFRA 900m"},
//     {id:"AUS ICFRA 900yd"},
//     {id:"AUS ICFRA 1000yd"},
//     {id:"AUS NRA 300m"},
//     {id:"AUS NRA 300yd"},
//     {id:"AUS NRA 400m"},
//     {id:"AUS NRA 400yd"},
//     {id:"AUS NRA 500m"},
//     {id:"AUS NRA 500yd"},
//     {id:"AUS NRA 600m"},
//     {id:"AUS NRA 600yd"},
//     {id:"AUS NRA 700m"},
//     {id:"AUS NRA 700yd"},
//     {id:"AUS NRA 800m"},
//     {id:"AUS NRA 800yd"},
//     {id:"AUS NRA 900m"},
//     {id:"AUS NRA 900yd"},
//     {id:"AUS NRA 1000m"},
//     {id:"AUS NRA 1000yd"},
//     {id:"AUS NRA Open 300"},
//     {id:"AUS NRA Open 500"},
//     {id:"AUS NRA Open 700"},
//     {id:"AUS NRA Open 1000"},
//     {id:"AUS Sniper CQB11"},
//    {id: "BEL ISSF 100m"},
//     {id:"DDS 12-delt"},
//     {id:"DDS 15m Pistol"},
//     {id:"DDS 15m Riff 4.5"},
//     {id:"DDS 15m Riff 5.6"},
//     {id:"DDS 200m"},
//     {id:"DDS 50m"},
//     {id:"DDS Hurtig"},
//     {id:"DDS Jagt 200mm"},
//     {id:"DDS Jagt 30.7mm"},
//     {id:"DDS Terræn C20"},
//     {id:"DDS Terræn C25"},
//     {id:"DEN 10-F"},
//     {id:"DEN 5A"},
//     {id:"DEN 5C"},
//     {id:"DEN 5D"},
//     {id:"DEN Finskytte"},
//     {id:"DEN Hind Siam O"},
//     {id:"DEN Hind Siam S"},
//     {id:"DEN MIL FIG 1/2"},
//     {id:"DEN MIL FIG 1/3"},
//     {id:"DEN MIL FIG 2/3"},
//     {id:"DEN MIL FIG 32"},
//     {id:"DEN Rådyr 10"},
//     {id:"DFS 100m"},
//     {id:"DFS 15m"},
//     {id:"DFS 15m KME"},
//     {id:"DFS 200m"},
//     {id:"DFS 300m"},
//     {id:"DSU 15m Riffel"},
//     {id:"FIN Running Elk"},
//     {id:"GB Hobson 60cm"},
//     {id:"GB NRA 200y"},
//     {id:"GB NRA 300y"},
//     {id:"GB NRA 400y"},
//     {id:"GB NRA 500y"},
//     {id:"GB NRA 600y"},
//     {id:"GB NRA FC 200y"},
//     {id:"GB NRA FC 300y"},
//     {id:"GB NRA FC 400y"},
//     {id:"GB NRA FC 500y"},
//     {id:"GB NRA FC 600y"},
//     {id:"GB NRA FC LR"},
//     {id:"GB NRA LR"},
//     {id:"GER BDMP 1"},
//     {id:"GER BDMP 3"},
//     {id:"GER BDMP 4"},
//     {id:"GER BDS 100m Z1"},
//     {id:"GER BDS 100m ZF Z4"},
//     {id:"GER BDS 300m Z9"},
//     {id:"GER BDS 300m ZF Z8"},
//     {id:"GER BDS ISSF 100m"},
//     {id:"GER DJV A2 S"},
//     {id:"GER DJV1 Rehbock"},
//     {id:"GER DJV2 Überlaufer"},
//     {id:"GER DJV3 Fuchs"},
//     {id:"GER DJV4 Gamsbock"},
//     {id:"GER DJV5 lfd.Keiler"},
//     {id:"GER DSB100m"},
//     {id:"IBU Biathlon"},
//     {id:"INT Palma FC LR"},
//     {id:"ISSF 10m Pistol"},
//     {id:"ISSF 10m Rifle"},
//     {id:"ISSF 25m Pistol 5.6"},
//     {id:"ISSF 25m Pistol 9.6"},
//     {id:"ISSF 25m RFP 5.6"},
//     {id:"ISSF 25m RFP 9.65"},
//     {id:"ISSF 300m"},
//     {id:"ISSF 50m Rifle"},
//     {id:"ISSF Run Boar 11 L"},
//     {id:"ISSF Run Boar 11 R"},
//     {id:"ISSF Run Boar Siam"},
//     {id:"LAT 4K"},
//     {id:"NOR 10m Bedrift Rif"},
//     {id:"NOR BEO Bjørn"},
//     {id:"NOR BEO Due"},
//     {id:"NOR BEO Ekorn"},
//     {id:"NOR BEO Gaupe 2"},
//     {id:"NOR BEO Grevling"},
//     {id:"NOR BEO Gråmåke"},
//     {id:"NOR BEO Hjort 2 "},
//     {id:"NOR BEO Mår"},
//     {id:"NOR BEO Rein 2"},
//     {id:"NOR BEO Rev 2"},
//     {id:"NOR BEO Rådyr 2"},
//     {id:"NOR BEO Sel"},
//     {id:"NOR BEO Sel-H"},
//     {id:"NOR BEO Skjære"},
//     {id:"NOR BEO Tiur"},
//     {id:"NOR BOJ Hjort"},
//     {id:"NOR BOJ Villsvin"},
//     {id:"NOR Dag Rev 5R"},
//     {id:"NOR Dag Rådyr H"},
//     {id:"NOR Dag Villsvin H"},
//     {id:"NOR Dag Villsvin V"},
//     {id:"NOR Felt 1/10"},
//     {id:"NOR Felt 1/3"},
//     {id:"NOR Felt 1/4"},
//     {id:"NOR Felt B65"},
//     {id:"NOR Felt C15"},
//     {id:"NOR Felt C20 LS"},
//     {id:"NOR Felt C30"},
//     {id:"NOR Felt C35"},
//     {id:"NOR Felt Hjul"},
//     {id:"NOR Felt HS LS"},
//     {id:"NOR Felt HStripe 22"},
//     {id:"NOR Felt M 1/4 LS"},
//     {id:"NOR Felt Mini 1/3"},
//     {id:"NOR Felt Mini 1/4"},
//     {id:"NOR Felt Minism�en"},
//    {id: "NOR Felt MS-F LS"},
//     {id:"NOR Felt MS-G LS"},
//     {id:"NOR Felt Prisme"},
//     {id:"NOR Felt Prisme LS"},
//     {id:"NOR Felt Sirkel 11c"},
//     {id:"NOR Felt Småen"},
//     {id:"NOR Felt Tønne 145"},
//     {id:"NOR Felt VStripe 22"},
//     {id:"NOR Hjort R5"},
//     {id:"NOR KM Elg 5"},
//     {id:"NOR KM Elg S5"},
//     {id:"NOR KM Rein 1H"},
//     {id:"NOR KM Rein 1S"},
//     {id:"NOR KM Rein 5"},
//     {id:"NOR MIL FIG 12"},
//     {id:"NOR MIL FIG 13"},
//     {id:"NOR MIL FIG 14"},
//     {id:"NOR Vilt 5"},
//     {id:"Nordisk Elg 10"},
//     {id:"NSF 15m"},
//     {id:"NSF 200m"},
//     {id:"NSF Coltskive"},
//     {id:"POL MIL 309"},
//     {id:"POL MIL 331"},
//    {id: "POL MIL 361"},
//     {id:"SWE 300m"},
//     {id:"SWE Björnmål"},
//     {id:"SWE Can Björn"},
//     {id:"SWE Can Elgkalv"},
//     {id:"SWE Can Rev"},
//     {id:"SWE Can Villsvin"},
//     {id:"SWE Fält 1/6"},
//     {id:"SWE Fält B45"},
//     {id:"SWE Fält C30"},
//     {id:"SWE Fält C40"},
//     {id:"SWE Fält L2"},
//     {id:"SWE Fält S20"},
//     {id:"SWE Fält S25"},
//     {id:"SWE Pek 1"},
//     {id:"SWE Pek 1/2"},
//     {id:"SWE Pek 1/4"},
//     {id:"SWE Pek 2"},
//     {id:"SWE Pek 3"},
//     {id:"SWE Pek 4"},
//     {id:"SWE Pek Hovud"},
//     {id:"SWE Polis Com 2"},
//     {id:"SWE Älg S10G"},
//     {id:"SWE Älg S5G"},
//     {id:"USA B27Q"},
// ];

const shootingProgramLanguages = {
  ab: "Abkhaz",
  aa: "Afar",
  af: "Afrikaans",
  ak: "Akan",
  sq: "Albanian",
  am: "Amharic",
  ar: "Arabic",
  an: "Aragonese",
  hy: "Armenian",
  as: "Assamese",
  av: "Avaric",
  ae: "Avestan",
  ay: "Aymara",
  az: "Azerbaijani",
  bm: "Bambara",
  ba: "Bashkir",
  eu: "Basque",
  be: "Belarusian",
  bn: "Bengali",
  bh: "Bihari",
  bi: "Bislama",
  bs: "Bosnian",
  br: "Breton",
  bg: "Bulgarian",
  my: "Burmese",
  ca: "Catalan",
  ch: "Chamorro",
  ce: "Chechen",
  ny: "Chichewa",
  zh: "Chinese",
  cv: "Chuvash",
  kw: "Cornish",
  co: "Corsican",
  cr: "Cree",
  hr: "Croatian",
  cs: "Czech",
  da: "Danish",
  dv: "Divehi",
  nl: "Dutch",
  dz: "Dzongkha",
  en: "English",
  eo: "Esperanto",
  et: "Estonian",
  ee: "Ewe",
  fo: "Faroese",
  fj: "Fijian",
  fi: "Finnish",
  fr: "French",
  ff: "Fula",
  gl: "Galician",
  ka: "Georgian",
  de: "German",
  el: "Greek",
  gn: "Guaraní",
  gu: "Gujarati",
  ht: "Haitian",
  ha: "Hausa",
  he: "Hebrew",
  hz: "Herero",
  hi: "Hindi",
  ho: "Hiri Motu",
  hu: "Hungarian",
  ia: "Interlingua",
  id: "Indonesian",
  ie: "Interlingue",
  ga: "Irish",
  ig: "Igbo",
  ik: "Inupiaq",
  io: "Ido",
  is: "Icelandic",
  it: "Italian",
  iu: "Inuktitut",
  ja: "Japanese",
  jv: "Javanese",
  kl: "Kalaallisut",
  kn: "Kannada",
  kr: "Kanuri",
  ks: "Kashmiri",
  kk: "Kazakh",
  km: "Khmer",
  ki: "Kikuyu",
  rw: "Kinyarwanda",
  ky: "Kyrgyz",
  kv: "Komi",
  kg: "Kongo",
  ko: "Korean",
  ku: "Kurdish",
  kj: "Kwanyama",
  la: "Latin",
  lb: "Luxembourgish",
  lg: "Ganda",
  li: "Limburgish",
  ln: "Lingala",
  lo: "Lao",
  lt: "Lithuanian",
  lu: "Luba-Katanga",
  lv: "Latvian",
  gv: "Manx",
  mk: "Macedonian",
  mg: "Malagasy",
  ms: "Malay",
  ml: "Malayalam",
  mt: "Maltese",
  mi: "Māori",
  mr: "Marathi (Marāṭhī)",
  mh: "Marshallese",
  mn: "Mongolian",
  na: "Nauruan",
  nv: "Navajo",
  nd: "Northern Ndebele",
  ne: "Nepali",
  ng: "Ndonga",
  nb: "Norwegian Bokmål",
  nn: "Norwegian Nynorsk",
  no: "Norwegian",
  ii: "Nuosu",
  nr: "Southern Ndebele",
  oc: "Occitan",
  oj: "Ojibwe",
  cu: "Old Church SlavonicChurch SlavonicOld Bulgarian",
  om: "Oromo",
  or: "Oriya",
  os: "Ossetian",
  pa: "(Eastern) Punjabi",
  pi: "Pāli",
  fa: "Persian",
  pl: "Polish",
  ps: "Pashto",
  pt: "Portuguese",
  qu: "Quechua",
  rm: "Romansh",
  rn: "Kirundi",
  ro: "Romanian",
  ru: "Russian",
  sa: "Sanskrit (Saṁskṛta)",
  sc: "Sardinian",
  sd: "Sindhi",
  se: "Northern Sami",
  sm: "Samoan",
  sg: "Sango",
  sr: "Serbian",
  gd: "Scottish Gaelic",
  sn: "Shona",
  si: "Sinhalese",
  sk: "Slovak",
  sl: "Slovene",
  so: "Somali",
  st: "Southern Sotho",
  es: "Spanish",
  su: "Sundanese",
  sw: "Swahili",
  ss: "Swati",
  sv: "Swedish",
  ta: "Tamil",
  te: "Telugu",
  tg: "Tajik",
  th: "Thai",
  ti: "Tigrinya",
  bo: "Tibetan Standard",
  tk: "Turkmen",
  tl: "Tagalog",
  tn: "Tswana",
  to: "Tonga",
  tr: "Turkish",
  ts: "Tsonga",
  tt: "Tatar",
  tw: "Twi",
  ty: "Tahitian",
  ug: "Uyghur",
  uk: "Ukrainian",
  ur: "Urdu",
  uz: "Uzbek",
  ve: "Venda",
  vi: "Vietnamese",
  vo: "Volapük",
  wa: "Walloon",
  cy: "Welsh",
  wo: "Wolof",
  fy: "Western Frisian",
  xh: "Xhosa",
  yi: "Yiddish",
  yo: "Yoruba",
  za: "Zhuang",
  zu: "Zulu",
};
